<template>
    <a-modal
      title="历史版本"
      :visible="historyIsShow"
      :confirm-loading="false"
      @cancel="close"
      width="60%"
    >
        <coententTable
            :y="height"
            :columns="columns"
            :dataSource="dataSource"
            :customSlot="customSlot"
        >
            <template v-slot:state="scopeVal">
                <span :class="[scopeVal.scope.state == 1?'Status1':scopeVal.scope.state == 2?'Status2':'']"
                    
                    >{{
                        scopeVal.scope.state == 0
                        ? "使用中"
                        : "已废弃"
                    }}</span
                >
            </template>
            <template v-slot:operation="scopeVal">
                <a
                @click="toDetails(scopeVal.scope.id)"
                class="btn"
                >查看</a
                >
            </template>
        </coententTable>
        <a-modal :title="'历史版本 v'+itemDel.version" :visible="detailsIsShow" @cancel="closetwo" width="60%">
            <div class="body-right">
                <div class="cont-box">
                    <div  class="content-title">{{itemDel.title}}</div>
                <div class="content-time">
                    <div>发布时间:{{itemDel.time}}</div>
                    <div style="margin-left: 100px;">来源：{{itemDel.source}}</div>
                </div>
                <div class="abstractText">{{itemDel.abstractText}}</div>
                <div class="cont-text" v-html="itemDel.content"></div>
                </div>
            </div>
        </a-modal>
    </a-modal>
</template>
<script>
import { selectList,selectOne} from './manuscripts.js'
import coententTable from "@/components/coentent_table.vue";
export default {
    components: {
        coententTable
    },
    props:{
        historyIsShow:{
            type:Boolean,
            default:false,
        },
        manuscriptId:{
            type:String,
            default:'',
        }
    },
    data(){
        return{
            columns: [
                {
                    title: "版本号",
                    dataIndex: "version",
                    width: "20%",
                },
                {
                    title: "创建日期",
                    dataIndex: "time",
                    width: "30%",
                },
                {
                    title: "状态",
                    dataIndex: "state",
                    scopedSlots: { customRender: "state" },
                },
                {
                    title: "创建人",
                    dataIndex: "user",
                },
                {
                    title: "操作",
                    dataIndex: "operation",
                    scopedSlots: { customRender: "action" }
                }
            ],
            customSlot: [
                {
                    name: "state",
                    customRender: "state",
                },
            ],
            dataSource:[],
            height:0,
            id:'',
            detailsIsShow:false,
            itemDel:{}
        }
    },
    mounted(){
        // this.getList()
    },
    methods:{
        getList(){
            const _this = this
            selectList({id:this.manuscriptId}).then(res=>{
                if(res.code == 0){
                    _this.dataSource = res.data
                }
            })
        },
        close(){
            this.$emit('closeHistory')
        },
        toDetails(id){
            selectOne({id:id}).then(res=>{
                if(res.code == 0){
                    this.itemDel =res.data
                    this.itemDel.version = Number(this.itemDel.version).toFixed(1)
                }
            })
            this.close()
            this.detailsIsShow = true
        },
        closetwo(){
            this.detailsIsShow = false
            this.open()
        },
        open(){
            this.$emit('toHistory')
        },
    }
}
</script>
<style lang="less" scoped>
 .body-right {
    flex: 1;
    margin-left: 24px;
    // border: solid 2px #dedede;
    border-radius: 4px;
    position: relative;
    .content-time{
        display: flex;
        // justify-content: space-between;
        padding: 20px 0;
        border-bottom: 1px solid #d9d9d9;
    }
    .content-title{
        color: rgba(48, 49, 51, 1);
        font-size: 23px;
        font-family: Roboto-regular;
        font-weight: 600;
        margin-top: 42px;
        padding-bottom: 20px;
        border-bottom: 1px solid #d9d9d9;
    }
    .cont-text{
        margin-top: 50px;
        overflow: auto;
        height: 450px;
    
    }
    .abstractText{
        padding: 20px 0;
        border-bottom: 1px solid #d9d9d9;
    }
}
/deep/.ant-modal-footer{
    display: none;
}
</style>